import { api } from '@/api'

export function fetchBookshelfList(pageIndex: number, pageSize: number) {
  return api.get<any, GetBookshelfListResponse>('/bookshelf/list', {
    params: { pageIndex, pageSize },
  })
}

export function fetchReadHistoryList(pageIndex: number, pageSize: number) {
  return api.get<any, GetReadHistoryListResponse>('/read/history/list', {
    params: { pageIndex, pageSize },
  })
}

export function deleteBookshelfBooks(contentIds: string[]) {
  return api.post<any, PostBookshelfDelResponse>('/bookshelf/del', { contentIds })
}

export function deleteReadHistory(contentIds: string[]) {
  return api.post<any, PostReadDelResponse>('/read/del', { contentIds })
}
